
// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/pages/Logout.js

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog'; // เปลี่ยนมาใช้ Dialog
import { ProgressSpinner } from 'primereact/progressspinner';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { API_URLS } from '../api/api';

const Logout = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false); // State สำหรับ Dialog
  const [message, setMessage] = useState(''); // ข้อความใน Dialog
  const [success, setSuccess] = useState(true); // สถานะสำเร็จ/ล้มเหลว
  const [loading, setLoading] = useState(true); // State สำหรับ ProgressSpinner

  useEffect(() => {
    const performLogout = async () => {
      const token = localStorage.getItem('token');

      if (token) {
        try {
          const response = await fetch(API_URLS.LOGOUT, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          });
          if (!response.ok) {
            throw new Error('Logout failed');
          }
          setMessage('Logged out successfully!');
          setSuccess(true);
          // ลบข้อมูลจาก localStorage
          localStorage.removeItem('token');
          localStorage.removeItem('userData');
          localStorage.removeItem('branch_ID');
          localStorage.removeItem('EventselectedEmployee');
          localStorage.removeItem('user_ID');
          localStorage.removeItem('maracar');
          setLoading(false); // ปิด spinner
          setVisible(true); // แสดง Dialog
          // รอ 2 วินาทีแล้วไปหน้า login
          setTimeout(() => {
            navigate('/');
          }, 2000);
        } catch (error) {
          console.error('Logout error:', error);
          setMessage('Failed to logout. Please try again.');
          setSuccess(false);
          setLoading(false); // ปิด spinner
          setVisible(true); // แสดง Dialog
        }
      } else {
        setMessage('No active session found. Logged out locally.');
        setSuccess(true);
        // ลบข้อมูลจาก localStorage
        localStorage.removeItem('token');
        localStorage.removeItem('userData');
        localStorage.removeItem('branch_ID');
        localStorage.removeItem('EventselectedEmployee');
        localStorage.removeItem('user_ID');

        setLoading(false); // ปิด spinner
        setVisible(true); // แสดง Dialog
        // รอ 2 วินาทีแล้วไปหน้า login
        setTimeout(() => {
          navigate('/');
        }, 2000);
      }
    };

    performLogout();
  }, [navigate]);

  return (
    <>
      {loading && (
        <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
          <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" />
        </div>
      )}
      <Dialog
        visible={visible}
        onHide={() => setVisible(false)} // ปิด Dialog อัตโนมัติเมื่อหมดเวลา
        header={success ? 'Logout Success' : 'Logout Failed'} // หัวข้อตามสถานะ
        modal
        style={{ width: '300px' }}
        footer={null} // ไม่มีปุ่มใน footer
      >
        <div style={{ textAlign: 'center' }}>
          <i
            className={success ? 'pi pi-check' : 'pi pi-exclamation-triangle'}
            style={{ fontSize: '2rem', color: success ? 'green' : 'red', marginBottom: '1rem' }}
          />
          <p>{message}</p>
        </div>
      </Dialog>
    </>
  );
};

export default Logout;